<template lang="pug">
span
  v-menu(v-model="showMenu" rounded="lg" allow-overflow attach :close-on-content-click="false" offset-y max-height="360" min-width="320" max-width="320" nudge-bottom="8" content-class="custom-menu")
    template(v-slot:activator="{ on, attrs }")
      v-btn.px-2.button-text-normal.button-filter.text-none.my-2(v-if="selectedOption && selectedValue" outlined rounded height="28" v-bind="attrs" v-on="on")
        v-icon.mr-1(@click.stop="clear" size=13) $yzi-x-circle
        .text-xs.font-semibold Reference
        .px-1.neutral400--text | 
        .text-xs.primary--text.font-medium {{ selectedReference }} {{ selectedValue }}
        v-icon.ml-1(size=16) $yzi-chevron-down
      v-btn.px-2.button-text-normal.border-dashed.button-filter.my-2(v-else outlined rounded height="28" v-bind="attrs" v-on="on")
        v-icon.mr-1(size=13) $yzi-plus-circle
        .text-xs.text-none.font-semibold Reference
    
    .pa-4.white(style="border-radius: inherit;")
      .font-semibold.mb-3.text-sm {{ $t('filter_by') }} reference
      y-select.mb-2(:items="options" item-text="name" item-value="id" v-model="option" small attach)
      .d-flex.align-start
        v-icon.mx-2(size=16 color="primary") $yzi-corner-down-right
        v-text-field.round-xl(v-model="value" hide-details outlined dense :placeholder="$t('type_a_value')")
    
    .bottom-0.sticky.z-1.white(style="border-radius: inherit;")
      .d-flex.align-center.px-4.py-3.border-t
        .text-sm.font-semibold.underline.normal-case.neutral700--text.cursor-pointer(v-if="value" @click="clear") {{ $t('clear') }}
        v-spacer
        v-btn.button-sm(@click="apply" color="primary" depressed :disabled="!value") {{ $t('apply') }}

</template>

<script>
export default {
  props: ['filter'],
  components: {},
  data: () => ({
    showMenu: false,
    option: 'rid__contains',
    value: null,
    options: [
      { id: 'rid', name: 'Is' },
      { id: 'rid__ne', name: 'Is not' },
      { id: 'rid__contains', name: 'Contains' },
      { id: 'rid__exclude', name: 'Does not contains' },
      { id: 'rid__startswith', name: 'Starts with' },
      { id: 'rid__endswidth', name: 'Ends with' },
    ],
    selectedOption: null,
    selectedValue: null,
  }),
  computed: {
    selectedReference () {
      for (const key in this.options) {
        const val = this.options[key]
        if (val.id === this.selectedOption) {
          return val.name
        }
      }
      return null
    }
  },
  watch: {
    filter: {
      handler () {
        if (!this.filter.key) { this.clearData() }
      } 
    },
  },
  methods: {
    clear () {
      this.clearData()
      this.$emit('update:filter', {})
    },
    clearData () {
      this.value = null
      this.selectedOption = null
      this.selectedValue = null
    },
    apply () {
      this.showMenu = false
      this.selectedOption = this.option
      this.selectedValue = this.value
      const filter = { key: this.option, value: this.value }
      this.$emit('update:filter', filter)
    }
  }
}
</script>

<style lang="scss" scoped>
.button-filter {
  min-width: 0 !important;
  color: #848484;
}
::v-deep {
  .custom-menu {
    overflow: unset;
    contain: unset;
  }
}
</style>